import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Sidebar from '@/components/Sidebar';
import api from '@/lib/api';
import '@/pages/Products.css';
import '@/pages/Clients.css';

const tabs = [
  { key: 'admin', label: 'Administracion' },
  { key: 'workers', label: 'Trabajadores' },
];

const formatDateTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return `${date.toLocaleDateString('es-AR')} ${date.toLocaleTimeString('es-AR', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })}`;
};

const ActivityHistory = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('admin');
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    load(activeTab);
  }, [activeTab]);

  const load = async (scope) => {
    try {
      setLoading(true);
      setError('');
      const { data } = await api.get('/activity-log', { params: { scope } });
      setEntries(data || []);
    } catch (err) {
      setError('Error al cargar historial');
      setEntries([]);
    } finally {
      setLoading(false);
    }
  };

  const renderEntry = (entry) => {
    const content = (
      <div key={entry.id} className="activity-entry history-entry">
        <div className="activity-dot"></div>
        <div className="activity-content">
          <div className="activity-meta">
            <span className="mono">{formatDateTime(entry.created_at)}</span>
            <span>{entry.actor_name || 'Sin usuario'}</span>
            <span>{entry.actor_role || '-'}</span>
          </div>
          <p>{entry.description}</p>
        </div>
      </div>
    );

    if (!entry.link) return content;
    return (
      <Link key={entry.id} to={entry.link} className="history-link">
        {content}
      </Link>
    );
  };

  return (
    <div className="dashboard-container">
      <Sidebar activePath={location.pathname} />

      <main className="main-content">
        <div className="page-header-row">
          <div>
            <h1>Historial</h1>
            <p className="dashboard-subtitle">
              Actividad registrada por administradores y trabajadores.
            </p>
          </div>
        </div>

        <div className="card editor-card">
          <div className="history-tabs">
            {tabs.map(tab => (
              <button
                key={tab.key}
                type="button"
                className={`history-tab ${activeTab === tab.key ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {error && <div className="login-error">{error}</div>}

          <div className="activity-timeline history-timeline">
            {loading ? (
              <div className="empty-state">Cargando historial...</div>
            ) : entries.length === 0 ? (
              <div className="empty-state">Todavia no hay actividad registrada.</div>
            ) : (
              entries.map(entry => renderEntry(entry))
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default ActivityHistory;
